<template>
    <div
        @click="$emit('click')"
        class="a-dialog dialog"
        :class="[
            {
                'a-dialog--pointer': cursorPointer!== false && $listeners.click,
                'a-dialog--flexible': isFlexible
            },
            `a-dialog--${pointerPosition}`,
        ]"
    >
        <div class="dialog__inner">
            <slot name="icon">
                <svg-icon
                    v-if="icon && icon !== 'none'"
                    original
                    :name="`navigation/${icon}`"
                    class="dialog__icon"
                    :color="fill || '_'"
                    :fill="Boolean(fill)"
                />
            </slot>
            <span class="dialog__text" :style="{fontSize}">
                <slot>
                    {{ text }}
                </slot>
            </span>
            <div class="dialog__arow"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ADialog',
    props: {
        pointerPosition:{
            type: String,
            default: 'left-bottom'
        },
        fontSize: {
            type: String,
            default: '20px'
        },
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        fill:{
            type: String,
            default: null
        },
        isFlexible: {
            type: Boolean,
            default: false
        },
        cursorPointer: {
            type: Boolean,
            default: null
        }
    },
}
</script>

<style lang="scss">
@import "a-dialog";   
</style>
